import ThanksModal from './ThanksModal';

export default ThanksModal;
